<template>
     <div
         v-show="$store.state.simplePlan.availableTreatmentPids.length === 0"
         :class="[$theme.contentBg, $theme.featuredText]"
         class="pm-smart-header-placeholder"
     >
         <v-icon v-show="selectedRegions.length === 0 || selectedRegions[0] === -1" :class="$theme.featuredText" style="margin: 10px 10px 0 -22px; transform: rotate(90deg);">
             subdirectory_arrow_right
         </v-icon>
         <span v-html="selectedRegions.length === 0 || selectedRegions[0] === -1 ? '' + $t('plan_calculator.select_region') : $t('plan_calculator.add_treatment')" />
         <v-icon v-show="selectedRegions.length > 0 && selectedRegions[0] !== -1" :class="$theme.featuredText" style="margin: 10px -22px 0 10px; transform: rotate(-90deg) scaleX(-1);">
             subdirectory_arrow_right
         </v-icon>
     </div>
</template>

<style>
    .pm-smart-header-placeholder {
        position: relative;
        z-index: 1;
        width: 100%;
        text-align: center;
        line-height:52px;
        height: 52px;
        box-shadow: inset 0 8px 15px rgba(0,0,0,.03), 0 8px 15px rgba(0,0,0,.03);
    }
    @media (min-width: 700px) {
        .pm-smart-header-placeholder {
            font-size: 18px;
            height: 52px !important;
            line-height: 52px !important;
        }
    }
</style>

<script>
    export default {
        props: {
            selectedRegions: {
                type: Object
            }
        }
    }
</script>
